import axios from "axios";
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Config } from "../../../../../../Config";
import PasswordInput from "../../../ShareElements/TextInput/PasswordInput";

const AccountSettings = (props) => {
  useEffect(() => {
    setHasMadeChanges(false);
  }, [props.CancelConfirmed]);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const [HasMadeChanges, setHasMadeChanges] = useState(false);
  const [OldPassMessage, setOldPassMessage] = useState(
    translateText("enter_current_pass")
  );
  const [NewPassMessage, setNewPassMessage] = useState(
    translateText("enter_new_pass")
  );
  const [RepeatPassMessage, setRepeatPassMessage] = useState(
    translateText("passwords_not_match")
  );
  const [SnackBarIsShown, setSnackBarIsShown] = useState(false);
  const [ShowHints, setShowHints] = useState(false);

  const toggleValidate = () => {
    const CurrentPass = document.getElementById("old-password-input").value;
    const NewPass = document.getElementById("new-password-input").value;
    const RepeatPass = document.getElementById(
      "repeat-new-password-input"
    ).value;

    if (CurrentPass.length === 0) {
      document.getElementById("old-password").classList.add("error-shown");
      setOldPassMessage(translateText("enter_current_pass"));
    } else if (NewPass.length === 0) {
      document.getElementById("new-password").classList.add("error-shown");
      setNewPassMessage(translateText("enter_new_pass"));
    } else if (CurrentPass === NewPass) {
      document.getElementById("policy-1").classList.add("wrong");
      document.getElementById("new-password").classList.add("error-shown");
      setShowHints(true);
      setNewPassMessage("");
    } else if (RepeatPass !== NewPass) {
      document
        .getElementById("repeat-new-password")
        .classList.add("error-shown");
    } else {
      if (NewPass.length < 8) {
        document.getElementById("policy-2").classList.remove("correct");
        document.getElementById("policy-2").classList.add("wrong");
        setShowHints(true);
      } else {
        document.getElementById("policy-2").classList.add("correct");
        setShowHints(false);
      }
      let WrongItems = 0;
      for (let i = 1; i < 6; i++) {
        if (
          document.getElementById("policy-" + i).classList.contains("wrong")
        ) {
          WrongItems++;
        }
      }
      if (WrongItems > 0) {
        document.getElementById("new-password").classList.add("error-shown");
        console.log("here");
        for (let i = 1; i < 6; i++) {
          if (
            !document
              .getElementById("policy-" + i)
              .classList.contains("correct")
          ) {
            document.getElementById("policy-" + i).classList.add("wrong");
            setShowHints(true);
          }
        }
        setNewPassMessage("");
      } else {
        setShowHints(false);
        // calling the login API to validate current password
        var Credentials = new FormData();
        Credentials.append("username", props.UserInfo.email);
        Credentials.append("password", CurrentPass);
        Credentials.append("grant_type", "password");
        var Request = {
          method: "POST",
          baseURL: window._env_.API_URL + Config.AuthBaseURL + "/oauth/token",
          headers: {
            Authorization: "Basic " + Config.IdentityToken,
          },
          data: Credentials,
        };
        axios(Request)
          .then((Res) => {
            // if password is correct, this block is executed
            console.log(Res);
            props.SetHasUnsavedChanges(false);

            if (props.SaveAndLeaveIsOn) {
              props.NavigateToSelectedTabAfterSave();
              props.SetSaveAndLeaveIsOn(false);
            }
            if (NewPass.length === 0) {
              document
                .getElementById("new-password")
                .classList.add("error-shown");
              setNewPassMessage("");
            } else if (NewPass.length < 8) {
              document
                .getElementById("new-password")
                .classList.add("error-shown");
              setNewPassMessage("");
            } else {
              requestChangePassword(NewPass);
            }
          })
          .catch((Err) => {
            // if password is wrong, this block is executed
            console.log(Err);
            document
              .getElementById("old-password")
              .classList.add("error-shown");
            setOldPassMessage("The password you entered is wrong.");
          });
      }
    }
  };

  const requestChangePassword = (NewPass) => {
    let Req = {
      method: "PUT",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/profile/preferences/change-password",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        password: NewPass,
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setHasMadeChanges(false);
        window.localStorage.setItem("HasUnsaveChanges", "0");
        // removing error state from the hints
        for (let i = 1; i < 6; i++) {
          document.getElementById("policy-" + i).classList.remove("correct");
          document.getElementById("policy-" + i).classList.remove("wrong");
        }
        setSnackBarIsShown(true);
        setTimeout(() => {
          dismissSnackbar();
        }, 3000);
      })
      .catch((Err) => {
        console.log(Err.response);
        if (Err.response !== undefined) {
          document.getElementById("new-password").classList.add("error-shown");
          setNewPassMessage("");
          setShowHints(true);
          if (NewPass.length < 8) {
            document.getElementById("policy-2").classList.remove("correct");
            document.getElementById("policy-2").classList.add("wrong");
          } else {
            document.getElementById("policy-2").classList.add("correct");
          }
          // 3) validating containing at least one capital letter
          let CapitalLetterRegEx = /(?=.*[A-Z])/g;
          if (NewPass.match(CapitalLetterRegEx)) {
            document.getElementById("policy-3").classList.add("correct");
            document.getElementById("policy-3").classList.remove("wrong");
          } else {
            document.getElementById("policy-3").classList.remove("correct");
            document.getElementById("policy-3").classList.add("wrong");
          }
          // 4) validationg at least one digit
          let DigitRegex = /[\d]{1}/;
          if (NewPass.match(DigitRegex)) {
            document.getElementById("policy-4").classList.add("correct");
            document.getElementById("policy-4").classList.remove("wrong");
          } else {
            document.getElementById("policy-4").classList.remove("correct");
            document.getElementById("policy-4").classList.add("wrong");
          }
          // 5) validating containing at least one special character
          let SpecialCharRegEx = /^(?=.*[@#$%^&!?+=]).*$/;
          if (NewPass.match(SpecialCharRegEx)) {
            document.getElementById("policy-5").classList.add("correct");
            document.getElementById("policy-5").classList.remove("wrong");
          } else {
            document.getElementById("policy-5").classList.remove("correct");
            document.getElementById("policy-5").classList.add("wrong");
          }
        }
      });
  };

  const dismissSnackbar = () => {
    setSnackBarIsShown(false);
    document.getElementById("notif-nav-item").click();
    document.getElementById("account-nav-item").click();
  };

  const handleBackButtonAction = () => {
    props.SetWillReturnToHomePage(true);
    if (props.HasUnsavedChanges) {
      props.DisplayUnsavedChangesModal(true);
    } else {
      document.getElementById("link-to-home").click();
    }
  };

  const handleInputsValueChanges = (Status) => {
    window.localStorage.setItem("HasUnsaveChanges", 1); // 1 means true, 0 means false
    setHasMadeChanges(Status);
    props.SetHasUnsavedChanges(true);
  };

  const handleCancel = () => {
    props.SetModalTypeIsCancel(true);
    props.SetHasUnsavedChanges(false);
    if (props.HasUnsavedChanges) {
      props.DisplayUnsavedChangesModal(true);
    }
  };

  return (
    <div className="bg-column">
      <section className="bg-colum-head">
        <i
          className="feather-arrow-left"
          onClick={() => handleBackButtonAction()}
        ></i>
        <NavLink to="/" id="link-to-home"></NavLink>
        <h1>{translateText("account_settings")}</h1>
        <div className="head-actions">
          <span
            className={
              HasMadeChanges
                ? "head-action-btn secondary-action"
                : "head-action-btn secondary-action disabled"
            }
            onClick={() => handleCancel()}
          >
            {translateText("cancel")}
          </span>
          <span
            className={
              HasMadeChanges
                ? "head-action-btn primary-action"
                : "head-action-btn primary-action disabled"
            }
            onClick={() => toggleValidate()}
            id="save-btn"
          >
            {translateText("save")}
          </span>
        </div>
      </section>
      {props.ResetPassFormIsShown ? (
        <div className="bg-form-body account-settings">
          <div className="account-settings-row">
            <p className="row-label">{translateText("email_address")}</p>
            <section className="row-input read-only">
              <i className="feather-mail"></i>
              <p>{props.UserInfo.email}</p>
            </section>
          </div>
          <div className="account-settings-row">
            <p className="row-label">
              {translateText("current_password")}
              <p className="required">*</p>
            </p>
            <PasswordInput
              LangData={props.LangData}
              Placeholder={translateText("current_password")}
              Id="old-password"
              SetHasMadeChanges={(Status) => handleInputsValueChanges(Status)}
              ErrorMessage={OldPassMessage}
              ApiPassValidation={false}
              AutoComplete="new-password"
            />
          </div>
          <div className="account-settings-row less-margined-row">
            <p className="row-label">
              {translateText("new_password")}
              <p className="required">*</p>
            </p>
            <PasswordInput
              LangData={props.LangData}
              Placeholder={translateText("new_password")}
              Id="new-password"
              HasHints
              HasPrevPass
              SetHasMadeChanges={(Status) => handleInputsValueChanges(Status)}
              ErrorMessage={NewPassMessage}
              ApiPassValidation={true}
              ShowHints={ShowHints} // triggered when fail to reset password
              IsShowingHints={(e) => setShowHints(e)}
              AutoComplete="new-password"
            />
          </div>
          <div className="account-settings-row">
            <p className="row-label">
              {translateText("confirm_password")}
              <p className="required">*</p>
            </p>
            <PasswordInput
              LangData={props.LangData}
              Placeholder={translateText("confirm_password")}
              Id="repeat-new-password"
              SetHasMadeChanges={(Status) => handleInputsValueChanges(Status)}
              ErrorMessage={RepeatPassMessage}
              ApiPassValidation={false}
              AutoComplete="new-password"
            />
          </div>
        </div>
      ) : null}
      {SnackBarIsShown ? (
        <section className="snack-bar">
          <p>Your password has been updated.</p>
          <span onClick={() => dismissSnackbar()}>DISMISS</span>
        </section>
      ) : null}
    </div>
  );
};

export default AccountSettings;
